import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import symbolImage from '../assets/enew-symbol.svg';
import awsPartnerBadge from '../assets/aws-partner-select-tier.svg';
import layout from '../styles/layout.module.css';
import styles from './Footer.module.css';

type FooterLink =
  | { label: string; kind: 'section'; sectionId: string }
  | { label: string; kind: 'route'; to: string };

const FOOTER_LINKS: readonly FooterLink[] = [
  { label: '会社概要', kind: 'section', sectionId: 'company-info' },
  { label: 'お知らせ', kind: 'route', to: '/news' },
  { label: 'お問い合わせ', kind: 'section', sectionId: 'contact' },
];

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleSectionLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ): void => {
    e.preventDefault();
    if (isHomePage) {
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const handlePrivacyLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>
  ): void => {
    if (location.pathname === '/privacy') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className={styles.siteFooter}>
      <div className={`${layout.wrap} ${styles.grid}`}>
        <div className={styles.brand}>
          <img
            src={symbolImage}
            alt=""
            width="36"
            height="36"
            className={styles.symbol}
          />
          <p className={styles.companyName}>株式会社eNEW Studio</p>
          <p className={styles.tagline}>クラウドが紡ぐ、新しい物語</p>
          <img
            src={awsPartnerBadge}
            alt="AWS Partner Network Select Tier Services パートナーバッジ"
            width="96"
            height="96"
            loading="lazy"
            decoding="async"
            className={styles.partnerBadge}
          />
        </div>

        <address className={styles.address}>
          〒920-0849
          <br />
          石川県金沢市堀川新町5番1号 アリマビル3F
        </address>

        <nav aria-label="フッターナビゲーション" className={styles.links}>
          <Link to="/privacy" onClick={handlePrivacyLinkClick}>
            プライバシーポリシー
          </Link>
          {FOOTER_LINKS.map((link) =>
            link.kind === 'route' ? (
              <Link key={link.label} to={link.to}>
                {link.label}
              </Link>
            ) : (
              <Link
                key={link.label}
                to={`/#${link.sectionId}`}
                onClick={(e) => handleSectionLinkClick(e, link.sectionId)}
              >
                {link.label}
              </Link>
            )
          )}
        </nav>
      </div>

      <div className={`${layout.wrap} ${styles.bottom}`}>
        <p className={styles.copyright}>
          &copy; 2025 株式会社eNEW Studio. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
